module.exports = __webpack_public_path__ + "img/airbase-stage_6.2.5db217aa.jpg";